export default "__VITE_ASSET__BNxUUWYM__"